import React, { useEffect, useState } from 'react';
import { Table } from 'tea-component';
import { SortByItemType } from '@/pages/intelligence/components/TableComponents/components/SortBy';
import {
  ActiveUserMetricColumn,
  dauTitle,
  revenueTitle,
  downloadTitle,
  arpuTitle,
  rankTitle,
  RankColumn,
} from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/ActiveUsersCloums';
import { DateColumns } from '@/pages/intelligence/pages/TopCharts/_config/TableCloums/DateCloums';
import { sortTableByMetric } from '@/pages/intelligence/utils/tableUtils';
import { useIntl, getLocale } from 'umi';
import { getActiveuserDetailMetricValueOfCvm } from '@/pages/intelligence/pages/TopCharts/MobileGames/components/GamesDetails/Stats/ActiveUserContext/_config/utils';
import { LANGUAGE_CN } from '@/pages/home/_config/config';

const { pageable, scrollable } = Table.addons;

const TrendsCard = (props: any) => {
  const {
    tableData = [],
    pageId,
    entityType = '',
    gameName,
    gameCover,
    dateType,
    startDate,
    endDate,
    dataSource,
    showRankSwitch,
    onTableSortChage,
    pageSortAttr: defaultPageSortAttr,
  } = props;

  const { formatMessage } = useIntl();
  const locale = getLocale();
  const [sortTableData, setSortTableData] = useState(tableData);
  const [pageSortAttr, setPageSortAttr] = useState(defaultPageSortAttr);

  const {
    // tablePageIndex,
    // tablePageSize,
    currentSortValue,
    currentSortMetric,
    currentRatioType,
    // currentOrderSource,
  } = pageSortAttr || {};

  useEffect(() => {
    onSortChage({
      sortMetric: currentSortMetric,
      sortVal: currentSortValue,
      ratioType: currentRatioType,
    });
  }, [tableData]);

  const handleSortChange = (e: SortByItemType) => {
    onTableSortChage?.(e);
    onSortChage(e);
  };

  const onSortChage = (e: SortByItemType) => {
    setPageSortAttr({
      currentSortValue: e.sortVal,
      currentSortMetric: e.sortMetric,
      currentRatioType: e.ratioType,
    });
    const sortTable = sortTableByMetric({
      tableData,
      sortParams: e,
      timeProperty: 'time',
      metricProperty: 'metric',
      growthProperty: 'growth_ratio',
    });
    setSortTableData(sortTable.slice(0));
  };

  const getMetricValueWithCompare = (cvm: any, sortMetric: string) => {
    return getActiveuserDetailMetricValueOfCvm(cvm, sortMetric, {
      entityType,
      gameName,
      gameCover,
      dateType,
      startDate,
      endDate,
    });
  };

  const getMetricCloums = (dataSource: string) => {
    const metricCloums: any[] = [];
    // DAU Revenue Download 每个数据源赋值一遍
    const titles = [];
    if (pageId === 'activeusers') {
      titles.push(dauTitle(dateType));
    } else if (pageId === 'revenue') {
      titles.push(revenueTitle);
      titles.push(arpuTitle);
    } else if (pageId === 'downloads') {
      titles.push(downloadTitle);
    }
    if (showRankSwitch) {
      titles.push(rankTitle);
    }
    titles.forEach((t) => {
      if (t.key === 'rank') {
        metricCloums.push(
          RankColumn({
            title: t.title,
            key: t.key,
            currentSortValue,
            currentSortKey: `${currentSortMetric}_${dataSource}_${currentRatioType}`,
            onSortChage: handleSortChange,
            width: t.width,
            isRank: true,
          }),
        );
      } else {
        metricCloums.push(
          ActiveUserMetricColumn({
            dataSource: dataSource === 'ogdb' ? 'databarin' : dataSource,
            title: locale === LANGUAGE_CN ? t?.title_cn || t?.title : t?.title,
            textContent: t.textContent,
            key: `${t.key}_${dataSource}`,
            sortMetric: t.key,
            metricKey: t?.metricKey || t.key,
            currentSortValue,
            currentSortKey: `${currentSortMetric}_${dataSource}_${currentRatioType}`,
            onSortChage: handleSortChange,
            width: t.width,
            width_cn: t?.width_cn,
            getMetricValueOfCvm: getMetricValueWithCompare,
            entityType,
          }),
        );
      }
    });
    return metricCloums;
  };

  return (
    <>
      <Table
        bordered="all"
        records={sortTableData}
        className="dbi-mobileGames-details-table"
        columns={[
          DateColumns({
            key: 'time',
            sortMetric: 'time',
            title: formatMessage({ id: `dbi_date` }),
            currentSortMetric,
            currentSortValue,
            dateType,
            onSortChage: handleSortChange,
            width: 180,
          }),
          ...getMetricCloums(dataSource),
        ]}
        addons={[
          pageable({
            stateTextVisible: true,
            pageSizeVisible: sortTableData?.length > 5,
            pageIndexVisible: sortTableData?.length > 5,
            jumpVisible: sortTableData?.length > 5,
            endJumpVisible: sortTableData?.length > 5,
            // pageSizeOptions: [5, 10, 15],
            pageSizeOptions: [10, 20, 30, 50, 100, 200],
            stateText: formatMessage(
              { id: 'dbi_pagination_total' },
              { total: sortTableData?.length ?? 0 },
            ),
          }),
        ]}
      />
    </>
  );
};

export default TrendsCard;
